import styled from 'styled-components';
import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_400,
  SYS_SPACE_FIXED_450,
} from '@oneaudi/unified-web-common';

export const TechnicalDataContainer = styled.div`
  width: 100%;
  margin-top: ${SYS_SPACE_FIXED_450};
`;

export const Module = styled.div`
  @media (max-width: 768px) {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  button {
    cursor: pointer;
  }
`;
export const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const Column = styled.div<{ isInitial: boolean }>`
  width: 100%;
  @media (min-width: 768px) {
    column-count: ${(props): string => (props.isInitial ? '1' : '2')};
    column-gap: ${(props): string => (props.isInitial ? '0' : '4.34%')};
    width: ${(props): string => (props.isInitial ? '47.83%' : '100%')};
  }
`;

export const Item = styled.dl`
  align-items: flex-start;
  display: inline-flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: ${SYS_SPACE_FIXED_400};
  padding: 0;
  width: 100%;
`;

export const Key = styled.dt`
  margin-bottom: 0;
  hyphens: auto;
  word-break: break-word;
  overflow-wrap: break-word;
  margin-right: ${SYS_SPACE_FIXED_150};
  width: 100px;
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    width: 112px;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: 115px;
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    width: 151px;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: 209px;
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    width: 289px;
  }
`;

export const Value = styled.dd`
  hyphens: auto;
  word-break: break-word;
  overflow-wrap: break-word;
  margin-bottom: 0;
  margin-left: 2%;
  width: 63%;
`;

export const Badge = styled.img`
  height: 28px;
  width: 28px;
`;
